export const enum NoticeType {
  General = "General",
  Important = "Important",
  Announcement = "Announcement"
}
